"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCachedBasketData = exports.getDataFromCookie = exports.BASKET_QTY_UPDATED_EVENT = void 0;
var _react = require("react");
var _env = _interopRequireDefault(require("../env/env"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var initialParse = false;
var basketData = {
  products: []
};
var cacheKey = 0;
var callbackCache = {};
var BASKET_COOKIE = /(?:^|; ?)cached_basket=([^;]+)/;
var BASKET_QTY_UPDATED_EVENT = exports.BASKET_QTY_UPDATED_EVENT = 'jl-events.browser.basketQuantityUpdated';
var generateCacheKey = function generateCacheKey() {
  return cacheKey++;
};
var mapServiceItems = function mapServiceItems(services) {
  var _services$split = services.split('-'),
    _services$split2 = _slicedToArray(_services$split, 5),
    productId = _services$split2[1],
    sku = _services$split2[2],
    itemPrice = _services$split2[3],
    qty = _services$split2[4];
  return {
    itemPrice: itemPrice,
    productId: productId,
    qty: qty,
    sku: sku
  };
};
var mapBasketItems = function mapBasketItems(item) {
  var _item$split = item.split('|'),
    _item$split2 = _slicedToArray(_item$split, 7),
    productId = _item$split2[1],
    sku = _item$split2[3],
    itemPrice = _item$split2[4],
    qty = _item$split2[5],
    additionalServices = _item$split2[6];
  var services = [];
  if (additionalServices) {
    // TODO: what if there are more than 1 "addons"?
    // I could only find an instance where there is 1 additional addon
    services.push.apply(services, _toConsumableArray([additionalServices].map(mapServiceItems)));
  }
  return {
    itemPrice: itemPrice,
    productId: productId,
    services: services,
    qty: qty,
    sku: sku
  };
};
var parseBasketCookie = function parseBasketCookie(basketCookie) {
  if (!basketCookie) {
    return {
      products: []
    };
  }

  // split all items in the cookie string
  var basket = basketCookie.split(/\|?\^/);

  // retrieve the totals (appear to ALAWYS be last two elements)
  var totals = basket.splice(basket.length - 2);

  // reduce the totals array and build an object of keys and values
  var information = totals.reduce(function (obj, info) {
    var _info$split = info.split('='),
      _info$split2 = _slicedToArray(_info$split, 2),
      key = _info$split2[0],
      value = _info$split2[1];
    return Object.assign(obj, _defineProperty({}, key, value));
  }, {});
  var products = basket.map(mapBasketItems);
  return _objectSpread({
    products: products
  }, information);
};
var getDataFromCookie = exports.getDataFromCookie = function getDataFromCookie() {
  var _ref = document.cookie.match(BASKET_COOKIE) || [],
    _ref2 = _slicedToArray(_ref, 2),
    basketCookie = _ref2[1];
  return parseBasketCookie(basketCookie);
};
var updateCachedBasketData = function updateCachedBasketData() {
  basketData = getDataFromCookie();
  Object.values(callbackCache).forEach(function (callback) {
    callback(basketData);
  });
};
var subscribeToCachedBasketData = function subscribeToCachedBasketData(key, callback) {
  callbackCache[key] = callback;
  if (!initialParse) {
    basketData = getDataFromCookie();
    initialParse = true;
  }
  callback(basketData);
};
var unSubscribeToCachedBasketData = function unSubscribeToCachedBasketData(key) {
  delete callbackCache[key];
};
if (_env.default.isClient) {
  window.addEventListener(BASKET_QTY_UPDATED_EVENT, updateCachedBasketData);
}
var useCachedBasketData = exports.useCachedBasketData = function useCachedBasketData() {
  var _useState = (0, _react.useState)(basketData),
    _useState2 = _slicedToArray(_useState, 2),
    cachedBasketData = _useState2[0],
    setCachedBasketData = _useState2[1];
  (0, _react.useEffect)(function () {
    var key = generateCacheKey();
    subscribeToCachedBasketData(key, setCachedBasketData);
    return function () {
      unSubscribeToCachedBasketData(key);
    };
  }, []);
  return cachedBasketData;
};